import { useQuery } from '@tanstack/react-query';

import getOperatorViolations from 'Api/report-attendance-operator-detail/getOperatorViolations';
import getOperatorViolationsRequest from './model/request/getOperatorViolationsRequest';
import getOperatorViolationsResponse from './model/response/getOperatorViolationsResponse';

const useGetOperatorViolations = ({ filter, selectedTab }) => {
  return useQuery({
    queryKey: ['report-operator-violations', filter],
    queryFn: async () => {
      const queries = getOperatorViolationsRequest(filter);

      const response = await getOperatorViolations(queries);

      const result = getOperatorViolationsResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: selectedTab === 'cameraViolation',
  });
};

export default useGetOperatorViolations;
